"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplementalDataSlug = exports.LoanProductSlugs = exports.LoanTapeTypeSchema = void 0;
const v4_1 = require("zod/v4");
exports.LoanTapeTypeSchema = v4_1.z.enum([
    'preassignedLoanTape',
    'masterLoanTape',
    'preassignedMasterLoanTape',
]);
exports.LoanProductSlugs = {
    AcmeCorpLoanProduct: 'acmeCorpLoanProduct',
    CoitTowerTechnologiesLoanProduct: 'coitTowerTechnologiesLoanProduct',
    EmbarcaderoTechnologiesLoanProduct: 'embarcaderoTechnologiesLoanProduct',
    AirbaseLoanProduct: 'airbaseLoanProduct',
    ArcLoanProduct: 'arcLoanProduct',
    BrightflowLoanProduct: 'brightflowLoanProduct',
    CaptainLoanProduct: 'captainLoanProduct',
    CaratsAndCakeLoanProduct: 'caratsAndCakeLoanProduct',
    CardlessLoanProduct: 'cardlessLoanProduct',
    CherryLoanProduct: 'cherryLoanProduct',
    ClaraLoanProduct: 'claraLoanProduct',
    CoastLoanProduct: 'coastLoanProduct',
    EvenLoanProduct: 'evenLoanProduct',
    FundrLoanProduct: 'fundrLoanProduct',
    ImprintLoanProduct: 'imprintLoanProduct',
    LawMeLoanProduct: 'lawMeLoanProduct',
    MultiplyLoanProduct: 'multiplyLoanProduct',
    MundiExpLoanProduct: 'mundiExpLoanProduct',
    MundiIfpLoanProduct: 'mundiIfpLoanProduct',
    NectarLoanProduct: 'nectarLoanProduct',
    NessLoanProduct: 'nessLoanProduct',
    ParafinLoanProduct: 'parafinLoanProduct',
    ParkerLoanProduct: 'parkerLoanProduct',
    RainLoanProduct: 'rainLoanProduct',
    RampLoanProduct: 'rampLoanProduct',
    RatioLoanProduct: 'ratioLoanProduct',
    TandymLoanProduct: 'tandymLoanProduct',
    ToolboxLoanProduct: 'toolboxLoanProduct',
    TripActionsLoanProduct: 'tripActionsLoanProduct',
    UpsideLoanProduct: 'upsideLoanProduct',
    UsAutoLoanProduct: 'usAutoLoanProduct',
    VayaLoanProduct: 'vayaLoanProduct',
};
var SupplementalDataSlug;
(function (SupplementalDataSlug) {
    SupplementalDataSlug["MundiIntlDebtorData"] = "mundiIntlDebtorData";
})(SupplementalDataSlug || (exports.SupplementalDataSlug = SupplementalDataSlug = {}));
//# sourceMappingURL=LoanProduct.js.map